// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"3852":"0ccad25865317fb8f382","6412":"14a5938dbd9eac4da080"}[chunkId] + ".css";
};